import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {BehaviorSubject, Subscription} from "rxjs";
import {ApiService} from "../../../services/api.service";
import {SearchOptions} from "../../../models/Search/SearchOptions";

@Component({
  selector: 'app-donor-table',
  templateUrl: './donor-table.component.html',
  styleUrls: ['./donor-table.component.scss']
})
export class DonorTableComponent implements OnInit, OnChanges, OnDestroy {

  @Input() title: string | undefined;

  // Flags
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  $firstLoad: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // RETURNED DATA
  $donors: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  // PAGINATION
  currentPage: BehaviorSubject<number> = new BehaviorSubject<number>(1);
  perPage: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  totalPages: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  currentPageSubscription: Subscription;
  searchOptionsSubscription: Subscription;

  // OPTIONS
  $searchOptions: BehaviorSubject<SearchOptions> = new BehaviorSubject<SearchOptions>({

  });

  constructor(public api: ApiService) { }

  ngOnInit(): void {

    this.searchOptions = {
      filters: [],
      extend: []
    }

    this.initializePagination();

    this.searchOptionsSubscription = this.$searchOptions.subscribe((data)=>{
      console.log('data changed');
      if(!this.$firstLoad.value){
        this.$firstLoad.next(true);
      }
      this.page = 1;
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
  }

  ngOnDestroy() {
    if(this.searchOptionsSubscription){
      this.searchOptionsSubscription.unsubscribe();
    }
    if(this.currentPageSubscription){
      this.currentPageSubscription.unsubscribe();
    }
  }

  get searchOptions(): SearchOptions{
    return this.$searchOptions.value;
  }

  set searchOptions(data: SearchOptions){
    this.$searchOptions.next(data);
  }

  get pageCount(): number | null{
    return this.totalPages.getValue();
  }

  set pageCount(data: number | null){
    this.totalPages.next(data);
  }

  get page(): number{
    return this.currentPage.getValue();
  }

  set page(data: number){
    this.currentPage.next(data);
  }

  getDonors(): void{
    this.$loading.next(true);
    this.api.apiPost('core/donors?page=' + this.page, this.searchOptions).then((res)=>{
      this.$loading.next(false);
      this.$donors.next(res.data);
      this.pageCount = res.total
    });
  }

  initializePagination(){
    if(!this.currentPageSubscription) {
      this.currentPageSubscription = this.currentPage.subscribe((data) => {
        if(this.$firstLoad.value){
          this.getDonors();
        }
      });
    }
  }

  pausePagination() {
    if (this.currentPageSubscription) {
        this.currentPageSubscription.unsubscribe();
    }
  }

}
